// extracted by css-extract-rspack-plugin
export default {"root":"root-E23f4E","posts":"posts-fKMfez","date":"date-Ew89Hk","more":"more-fIfPNd"};